module.exports = __webpack_public_path__ + "static/media/notification.e486db32.svg";